/**
 * @generated SignedSource<<6a782e0a979c89127238e3ce33f2b1ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePoll",
    "kind": "LinkedField",
    "name": "createPoll",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createCommentFormCreatePollMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createCommentFormCreatePollMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c0da7b2fc7a357000d6685656e8124e",
    "id": null,
    "metadata": {},
    "name": "createCommentFormCreatePollMutation",
    "operationKind": "mutation",
    "text": "mutation createCommentFormCreatePollMutation(\n  $request: CreatePollRequestInput!\n) {\n  createPoll(request: $request) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "cf4aeb9d4a98a4c7e9e9711c295f9930";

module.exports = node;
